import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { BasicConfiguration } from "@/pages/3d/examples/BasicConfiguration";

export const Route = createFileRoute("/demo/3d/examples/basic")({
  component: () => (
    <BabylonSceneWrapper>
      <BasicConfiguration />
    </BabylonSceneWrapper>
  ),
});
